/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2024, Zumper
 * @description This file was created when removing ms.macro from the project.
 * It provides common values for time in milliseconds.
 */

/** One second in milliseconds */
export const ONE_SECOND = 1000
/** One minute in milliseconds */
export const ONE_MINUTE = 60000
/** One hour in milliseconds */
export const ONE_HOUR = 3600000
/** One day in milliseconds */
export const ONE_DAY = 86400000
/** One week in milliseconds */
export const ONE_WEEK = 604800000
